const { createApp } = Vue

createApp({
  data() {
    return {
      inputVal:"",
      emailVal:"",
      customerName:"",
      orderNumber:"",
      orderLineItems:"",
      shippingCountry:"",
      fulfillDate:"",
      validate: false,
      orderFoundError:false,
      returnWindowOver:false,
      cancelOrRefunded:false,
      notShippidYet:false,
      orderformHide:true,
      lineItemsHide:false,
      reviewItemsHide:false,
      isLoader:false,
      returnSelectEl:true,
      isChecked:false,
      reviewLineButton:false,
      isFinalChecked: false,
      orderLinePids: [],
      orderFinalArray:[],
      reviewFinalItems:[],
      formPosted:false,
      exchangeFalse:true,
      refundLineItems:[],
      errorSubmitFinalForm:false,
      noActionSelected:false,
      step1Done:false,
      step2Done:false,
      step3Done:false,
    }
  },
  computed: {
    isButtonDisabled() {
      return !this.isFinalChecked // check if the checkbox is not checked
    }
  },
  filters: {
    formatMoneyWithCurrency(value) {
      return value.toLocaleString('en', { style: 'currency', currency: window.PXUTheme.context.cart.currency });
    },
  },
  mounted() {
    this.isMount = true;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if(urlParams.get('request_submitted')) {
      this.formPosted = true
    }
  },
  methods:{
    formatMoney(cents, format) {
      const moneyFormat = '${{amount}}';
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },
    getOrder() {
      this.lineItemsHide = false;
      if (this.emailVal && this.inputVal) {
        this.isLoader = true
        fetch(`https://order-api-echt.inscoder.workers.dev/${this.inputVal}`)
        .then((response) => response.json())
        .then((data) => {
          this.step1Done = true;
          this.isLoader = false;
          let diffInDays
          let isRefundtoProceed = false

          if(data.orders.edges[0].node.fulfillments.length > 0) {
            this.fulfillDate = data.orders.edges[0].node.fulfillments[0].createdAt;
            const timeString = this.fulfillDate.split('T')[0];
            const pastDate = new Date(timeString);
            const today = new Date();
            const diffInTime = today.getTime() - pastDate.getTime();
            diffInDays = Math.floor(diffInTime / (1000 * 3600 * 24));
          }

          if(data.orders.edges[0].node.refunds.length > 0) {

            function getTotalQuantity(refundsArray) {
              return refundsArray.reduce((totalQuantity, refund) => {
                const lineItems = refund.refundLineItems.edges;
                for (const edge of lineItems) {
                  const quantity = edge.node.lineItem.quantity;
                  totalQuantity += quantity;
                }
                return totalQuantity;
              }, 0);
            }

            const mainLineItemsQuantity = data.orders.edges[0].node.lineItems.edges.reduce((sum, product) => sum + product.node.quantity, 0);
            const refundedLineItemsQuantity = getTotalQuantity(data.orders.edges[0].node.refunds)

            if (refundedLineItemsQuantity < mainLineItemsQuantity) {
              isRefundtoProceed = true;
              this.refundLineItems = [];

              data.orders.edges[0].node.refunds.forEach(refund => {
                refund.refundLineItems.edges.forEach(edge => {
                  this.refundLineItems.push(edge.node.lineItem);
                });
              });
            }

          } else {
            isRefundtoProceed = true
          }

          if(this.emailVal.toLowerCase() === data.orders.edges[0].node.email.toLowerCase()
            && (data.orders.edges[0].node.cancelledAt == null && isRefundtoProceed)) {
            if(data.orders.edges[0].node.displayFulfillmentStatus == 'FULFILLED') {
              this.notShippidYet = false;

              if (diffInDays <= 45) {
                this.validate = true;
                this.orderFoundError = false;
                this.orderformHide = false;
                this.returnWindowOver = false;
                this.orderNumber = data.orders.edges[0].node.name;
                this.customerName = (data.orders.edges[0].node.customer != null) ? data.orders.edges[0].node.customer.displayName : "";
                this.shippingCountry = (data.orders.edges[0].node.shippingAddress != null) ? data.orders.edges[0].node.shippingAddress.country : "";
                this.orderLineItems = data.orders.edges[0].node.lineItems.edges;
                this.currencyCode = data.orders.edges[0].node.presentmentCurrencyCode;
                this.orderLinePids = [];
                for (i=0; i < data.orders.edges[0].node.lineItems.edges.length; i++) {
                  this.orderLinePids.push(data.orders.edges[0].node.lineItems.edges[i].node.product.id)
                }
              } else {
                this.returnWindowOver = true;
                this.cancelOrRefunded = true;
              }
            } else {
              this.notShippidYet = true
            }

          } else {
            this.validate = false;

            if(this.emailVal === data.orders.edges[0].node.email && (data.orders.edges[0].node.cancelledAt != null || !isRefundtoProceed)) {
              this.cancelOrRefunded = true;
              this.returnWindowOver = true
            } else {
              this.orderFoundError = true;
              this.returnWindowOver = false
              this.notShippidYet = false;
            }
          }

        }).catch((error) => {
            this.validate = false;
            this.orderFoundError = true;
            this.isLoader = false
        });
      }
    },
    getOrderLineItems() {
      let storeFrontToken = '48d513be4c137b862b00deea23f49705';
      this.isLoader = true
      const query = `
        query {
          nodes(ids: ${JSON.stringify(this.orderLinePids)}) {
            ... on Product {
              featuredImage {
                src
              }
              variants(first: 100) {
                edges {
                  node {
                    title,
                    quantityAvailable,
                    sku,
                    id
                  }
                }
              }
            }
          }
        }
      `;

      let orderFinalArrays = [];
      fetch('https://echt-sportswear.myshopify.com/api/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storeFrontToken
        },
        body: JSON.stringify({ query })
      })
        .then(response => response.json())
        .then(data => {
          this.step2Done = true;
          this.isLoader = false;
          this.lineItemsHide = true;
          this.isChecked = false;
          this.reviewItemsHide = false;

          console.log(data, 'data')

          for(j=0; j < this.orderLineItems.length; j++) {
            console.log(this.orderLineItems[j], 'orderLineItems')
            // let embroidery = false
            // if(this.orderLineItems[j].node.customAttributes.length > 0) {
            //   this.orderLineItems[j].node.customAttributes.some(element => {
            //     if (element.key.includes('embroidery')) {
            //       embroidery = true;
            //     }
            //   });
            // }
            if(!this.orderLineItems[j].node.title.toLowerCase().includes('icon')
              && !this.orderLineItems[j].node.title.toLowerCase().includes('protect')
            ) {
              const variantId = this.orderLineItems[j].node.variant?.id;
              
              const variantSku = data.data.nodes[j]?.variants.edges.find(
                v => v.node.id === variantId
              )?.node.sku || '-';

              var linevarPrice = (this.orderLineItems[j].node.variant != null) ? parseFloat(this.orderLineItems[j].node.variant.price) : parseFloat(this.orderLineItems[j].node.discountedUnitPrice);
              var linevarComparePrice = (this.orderLineItems[j].node.variant != null && this.orderLineItems[j].node.variant.compareAtPrice != null) ? parseFloat(this.orderLineItems[j].node.variant.compareAtPrice) : 0
              orderFinalArrays.push({
                productTitle: this.orderLineItems[j].node.title,
                productSku: variantSku,
                productPrice: this.orderLineItems[j].node.discountedTotalSet.presentmentMoney.amount,
                productVariantTitle: this.orderLineItems[j].node.variantTitle,
                productQty: this.orderLineItems[j].node.quantity,
                fetauredImage: (data.data.nodes[j] != null) ? data.data.nodes[j].featuredImage.src : this.orderLineItems[j].node.image.src,
                productVariants:(data.data.nodes[j] != null) ? data.data.nodes[j].variants : null,
                exchange:(data.data.nodes[j] != null) ? !data.data.nodes[j].variants.edges.every(obj => obj.node.quantityAvailable === 0) : false,
                productVarId: (this.orderLineItems[j].node.variant != null) ? this.orderLineItems[j].node.variant.id.split('/').pop() + '-' + j : null,
                lineItemId:this.orderLineItems[j].node.id,
                isItemRefunded:false,
                linevarPrice: linevarPrice,
                linevarComparePrice: linevarComparePrice,
                // lineStatus: linevarComparePrice > linevarPrice ? 'exchange' : 'refund',
                lineStatus: 'exchange',
                productTags: this.orderLineItems[j].node.product.tags
              });
            }
          }

          for (let k = 0; k < orderFinalArrays.length; k++) {
            if (orderFinalArrays[k].productQty > 1) {
              var productPriceEach =  parseFloat(orderFinalArrays[k].productPrice) / orderFinalArrays[k].productQty;
              for (let l = 1; l < orderFinalArrays[k].productQty; l++) {
                orderFinalArrays.splice(k + l, 0,
                  {
                    ...orderFinalArrays[k], productQty: 1 , productPrice : productPriceEach , productVarId: orderFinalArrays[k].productVarId.concat(`+${l}`) });
              }
              orderFinalArrays[k].productQty = 1;
              orderFinalArrays[k].productPrice = productPriceEach;
            }
          }
          this.orderFinalArray = orderFinalArrays;
          let itemsOfRefundArray = this.refundLineItems;

          console.log(this.orderFinalArray, 'orderFinalArray')

          if(itemsOfRefundArray.length > 0) {
            const withRefundedItemsArray = this.orderFinalArray.map((final) => {
              const matchedItem = itemsOfRefundArray.find((refunded) => refunded.id === final.lineItemId);
              let remainingQuantity = matchedItem ? matchedItem.quantity : 0;

              if (remainingQuantity > 0) {
                final.isItemRefunded = true;
                remainingQuantity--;
              }
              return { ...final, quantity: final.productQty, isItemRefunded: final.isItemRefunded };
            });

            this.orderFinalArray = withRefundedItemsArray
          }
          const isAllItemsRequested = this.orderFinalArray.every(element => element.isItemRefunded === true)
          const isAllOnFinalSale = this.orderFinalArray.every(element => element.tags.includes('__label:Final_Sale'));

          this.noActionSelected = false
          if(isAllItemsRequested || isAllOnFinalSale) {
            this.noActionSelected = true
          }
        })
        .catch(error => {
          this.isLoader = false
        });
    },

    handleDropdown(event,productVarId) {
      for(j=0; j < this.orderFinalArray.length; j++) {
        if(productVarId == this.orderFinalArray[j].productVarId)
          this.orderFinalArray[j].lineStatus = event.target.value.toLowerCase()
      }

      const type_el = document.querySelectorAll('.select_type');
      const isAllNoAction = Array.from(type_el, dropdown => dropdown.value).every(value => value === 'No-action');

      if(isAllNoAction) {
        this.noActionSelected = true
      } else {
        this.noActionSelected = false
      }
    },
    decrementQuantity(e) {
      let inputQty = e.target.closest('.qty_select').querySelector('input[type="number"]');
      if(inputQty.value > 1) {
        inputQty.value = inputQty.value - 1;
      }
    },
    incrementQuantity(e) {
      let inputQtys = e.target.closest('.qty_select').querySelector('input[type="number"]');
      let maxQty = inputQtys.getAttribute('max')
      if(inputQtys.value < maxQty)
        inputQtys.value = Number(inputQtys.value) + 1;
    },
    handleItemSelect(event) {
      let nextElEventsTrue = event.target.closest('.single__item').querySelector('.single__inner');
      let checkBoxEls = document.querySelectorAll('.select_item_check input[type="checkbox"]');

      let falsyArray = [];
      checkBoxEls.forEach(function(check){
        falsyArray.push(check.checked);
      })
      if(falsyArray.includes(true)) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
    },
    reviewLineItems(event) {
      const reasonElOfReturn = document.querySelectorAll('[name="refund-reason"]')
      const reasonElOfExchange = document.querySelectorAll('[name="exchange-reason"]');
      const productElOfExchange = document.querySelectorAll('[name="exchange-product"]')
      let validItemsSelection = true;
      reasonElOfReturn.forEach(function(select_refund){
        if(select_refund.value == 'Refund Reason') {
          select_refund.style.border = '2px solid red';
          validItemsSelection = false
        } else {
          select_refund.style.border = '1px solid #EAEAEA';
        }
      })

      reasonElOfExchange.forEach(function(select_exchange){
        if(select_exchange.value == 'Exchange Reason') {
          select_exchange.style.border = '2px solid red';
          validItemsSelection = false
        } else {
          select_exchange.style.border = '1px solid #EAEAEA';
        }
      });

      productElOfExchange.forEach(function(product_el){
        if(product_el.value == 'Exchange Product') {
          product_el.style.border = '2px solid red';
          validItemsSelection = false
        } else {
          product_el.style.border = '1px solid #EAEAEA';
        }
      });

      if(!validItemsSelection) {
        return;
      }
      this.step3Done = true;
      window.scrollTo({top: 0, behavior: 'smooth'});
      this.reviewItemsHide = true
      let itemSelector = document.querySelectorAll('.single__item')
      let finalArrayOrder = [];
      itemSelector.forEach((item, index) => {
        let select_type = item.querySelector('.select_type');
        if(select_type && select_type.value !== 'No-action') {
          let finalTitle = item.querySelector('.prouct_meta h4').innerHTML;
          let finalVar = item.querySelector('.prouct_meta p').innerHTML.trim() || '-';
          let finalPrice = item.querySelector('.prouct_meta p.price').innerHTML;
          let finalSelectType = item.querySelector('select[name="return-type"]').value;
          let finalImageSrc = item.querySelector('.product_image img').getAttribute('src');
          let finalRefundReason,finalExchangeReason,finalExchangedProduct;
          let finalNote = item.querySelector('.add_notes textarea[name="contact[additional_notes]"]')?.value?.trim() || '-';
          let finalSku = this.orderFinalArray[index].productSku || '-';
        

          if(item.querySelector('select[name="exchange-reason"]')) {
            let exchangeReasonEl = item.querySelector('select[name="exchange-reason"]');
            let exchangeProductEl = item.querySelector('select[name="exchange-product"]');
            
            finalExchangeReason = (exchangeReasonEl.value === 'Exchange Reason' || !exchangeReasonEl.value) ? '-' : exchangeReasonEl.value;
            finalExchangedProduct = (exchangeProductEl.value === 'Exchange Product' || !exchangeProductEl.value) ? '-' : exchangeProductEl.value;
          } else {
            finalExchangeReason = '-';
            finalExchangedProduct = '-';
          }

          if(item.querySelector('select[name="refund-reason"]')) {
            let refundReasonEl = item.querySelector('select[name="refund-reason"]');
            finalRefundReason = (refundReasonEl.value === 'Refund Reason' || !refundReasonEl.value) ? '-' : refundReasonEl.value;
          } else {
            finalRefundReason = '-';
          }

          finalArrayOrder.push({
            line:index,
            finalTitle: finalTitle,
            finalVar: finalVar,
            finalPrice:finalPrice,
            finalSku: finalSku,
            finalSelectType: finalSelectType,
            finalRefundReason: finalRefundReason,
            finalExchangeReason: finalExchangeReason,
            finalExchangedProduct: finalExchangedProduct,
            finalImageSrc:finalImageSrc,
            finalNote: finalNote
          })
        }
      });
      this.reviewFinalItems = finalArrayOrder;
    },
    refreshItems(){

        if(this.reviewItemsHide){
          this.lineItemsHide = true;
          this.reviewItemsHide = false;

          this.$nextTick(() => {
            let line_to_refill = []
            this.reviewFinalItems.forEach(function(line){
                let prevSelectEl = document.querySelector(`.single__item[data-index="${line.line}"] select.select_type`)
                let prevSelectVar = document.querySelector(`.single__item[data-index="${line.line}"] select.variants`)
                let prevExchangeReason = document.querySelector(`.single__item[data-index="${line.line}"] select.exchange_reason`)
                let prevReturnReason = document.querySelector(`.single__item[data-index="${line.line}"] select.return_reason`)
                let prevNotes = document.querySelector(`.single__item[data-index="${line.line}"] textarea[name="contact[additional_notes]"]`)
                
                prevSelectEl.value = line.finalSelectType;
                prevSelectEl.dispatchEvent(new Event('change'));

                if(prevReturnReason) {
                    prevReturnReason.value = line.finalRefundReason;
                    prevReturnReason.style.border = '1px solid #EAEAEA'
                }

                if(prevSelectVar) {
                    prevSelectVar.value = line.finalExchangedProduct
                    prevExchangeReason.value = line.finalExchangeReason
                    prevSelectVar.style.border = '1px solid #EAEAEA'
                    prevExchangeReason.style.border = '1px solid #EAEAEA'
                }

                if(prevNotes) {
                    prevNotes.value = line.finalNote || '';
                }
                
                line_to_refill.push(line.line)
            })

            let itemSelectors = document.querySelectorAll('.single__item');
            itemSelectors.forEach(function(lines,index){
                if(!line_to_refill.includes(index)) {
                    lines.querySelector('.select_type').value = 'No-action'
                    let notes = lines.querySelector('textarea[name="contact[additional_notes]"]');
                    if(notes) {
                        notes.value = '';
                    }
                }
            })
          })
        } else {
          this.reviewItemsHide = false;
        }

    },
    resetItems(){
      window.scrollTo({top: 0, behavior: 'smooth'});
      this.reviewItemsHide = false,
      this.isChecked = false;

      this.$nextTick(() => {
        const itemSelector = document.querySelectorAll('.order_items .single__item');

        itemSelector.forEach(function(item,index){
          const select_types = item.querySelector('.select_type');
          const refund_reason = item.querySelector('.return_reason');
          const exchangeProductEl = item.querySelector('[name="exchange-product"]');
          const exchangeReason = item.querySelector('.exchange_reason');

          if(select_types) {
            const firstAvailableOption = Array.from(select_types.options).find(option => !option.disabled);
            select_types.selectedIndex  = firstAvailableOption.index;
            select_types.dispatchEvent(new Event('change'));
          }

          if(refund_reason) {
            refund_reason.style.border = '1px solid #EAEAEA'
            refund_reason.value = 'Refund Reason';
            refund_reason.dispatchEvent(new Event('change'));
          }

          if(exchangeProductEl && exchangeReason) {
            exchangeProductEl.value = 'Exchange Product';
            exchangeProductEl.dispatchEvent(new Event('change'));
            exchangeProductEl.style.border = '1px solid #EAEAEA'
            exchangeReason.value = 'Exchange Reason';
            exchangeReason.dispatchEvent(new Event('change'));
            exchangeReason.style.border = '1px solid #EAEAEA'
          }
        })
      })
    },
    submitNewRequest(){
      window.history.replaceState({}, document.title, window.location.pathname);
      location.reload();
    },
    klaviyoSubmit() {
      const options = {
        method: 'POST',
        mode:"cors",
        headers: {
            "accept": 'application/json',
            "revision": '2023-02-22',
            'content-type': 'application/json'
        },

        body: JSON.stringify({data: {
                    type: "event",
                    attributes: {
                        profile: {$email: "harshil.gangani@inscoder.com"}, // use "this.emailVal" instead dummy when theme goes live in future
                        metric: {name: "ECHT Return"},
                        properties: {customer: this.customerName, orderNumber:this.orderNumber}
                    }
                }
            })
        };

        fetch("https://a.klaviyo.com/client/events/?company_id=N6JQTv", options)
        .then(response => {
            return response.json()
        })
        .then(response => console.log(response))
        .catch(err => console.error(err));
    }
  }
}).mount('#refund-app')